import { BaseApi } from './BaseApi';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { BaseLocalStorageApi } from './localStorage/BaseLocalStorageApi';
import { plaidSlice } from './plaidSlice/plaidSlice';

const reducers = {
  plaidSlice: plaidSlice.reducer,
  [BaseApi.reducerPath]: BaseApi.reducer,
  [BaseLocalStorageApi.reducerPath]: BaseLocalStorageApi.reducer,
};
const reducer = combineReducers(reducers);
type RootState = ReturnType<typeof reducer>;

export const makeStore = () =>
  configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(BaseApi.middleware).concat(BaseLocalStorageApi.middleware),
  });

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const wrapper = createWrapper<AppStore>(makeStore);

// References
// https://github.com/kirill-konshin/next-redux-wrapper?tab=readme-ov-file#redux-toolkit
// https://github.com/kirill-konshin/next-redux-wrapper/blob/master/packages/demo-redux-toolkit/store.ts
